import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import AgreementsList from "@/components/agreements/AgreementsList";
import SignedRecordsTable from "@/components/agreements/SignedRecordsTable";
import RichContent from "@/components/RichContent";

const BASE = "/manager/agreements-hub";

export default function CenterAgreements() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["center-agreements"], queryFn: () => api.get(BASE).then((r) => r.data) });
  const { data: options = {} } = useQuery({ queryKey: ["center-agreements-options"], queryFn: () => api.get(`${BASE}/options`).then((r) => r.data) });
  const canManage = !!data?.can_manage;
  return (
    <div className="space-y-10" data-testid="center-agreements">
      <section>
        <h2 className="font-serif text-2xl text-[#1A242B]">Center Agreements{data?.center?.name ? ` · ${data.center.name}` : ""}</h2>
        <p className="text-sm text-[#4A5D6B] mt-1 mb-4">Waivers and participation agreements for your center. Assign them to your services and offerings — leave everything unselected to require one for every booking at your center.</p>
        <AgreementsList items={data?.agreements || []} base={BASE} archiveUrl={(a, action) => `${BASE}/${a.id}/${action}`} options={options}
          targets={["services", "packages", "memberships", "service_types", "scoped_hint"]} canEdit={canManage}
          onChanged={() => qc.invalidateQueries({ queryKey: ["center-agreements"] })} testid="center-agreements-list" newLabel="New center agreement" />
      </section>
      {(data?.master_applies || []).length > 0 && (
        <section data-testid="center-master-agreements">
          <h3 className="font-serif text-xl text-[#1A242B] mb-1">Platform agreements that also apply</h3>
          <p className="text-xs text-[#8FA89B] mb-3">Managed by Enhancing Your World — read only.</p>
          <ul className="space-y-2">
            {data.master_applies.map((a) => (
              <li key={a.id}><details className="rounded-2xl border border-[#E5E0D8] bg-white p-4">
                <summary className="cursor-pointer text-sm text-[#1A242B]"><b>{a.title}</b> <span className="text-[#8FA89B]">· v{a.version}</span></summary>
                <RichContent text={a.content} className="mt-3 text-sm text-[#4A5D6B]" />
              </details></li>
            ))}
          </ul>
        </section>
      )}
      <section>
        <h3 className="font-serif text-xl text-[#1A242B] mb-3">Signed records at your center</h3>
        <SignedRecordsTable endpoint={`${BASE}/signed`} testid="center-signed-records" />
      </section>
    </div>
  );
}
